export interface ScanPostTypeOption {
  value: string;
  label: string;
  subLabel?: string;
  description?: string;
}

export interface ScanPostOption {
  type: string;
  value: string;
  label: string;
}

export interface ScanPostCatalog {
  types: ReadonlyArray<ScanPostTypeOption>;
  scanPosts: ReadonlyArray<ScanPostOption>;
}

export const getScanPostsOfType = (
  scanPostType: string | undefined,
  { scanPosts }: ScanPostCatalog
): ScanPostOption[] =>
  scanPosts.filter(scanPost => scanPost.type === scanPostType);

export const isScanPostComplete = (
  scanPost: string | undefined,
  catalog: ScanPostCatalog
): boolean => {
  if (!scanPost) {
    return false;
  }

  if (catalog.scanPosts.some(({ value }) => value === scanPost)) {
    return true;
  }

  return catalog.types.some(
    ({ value }) =>
      value === scanPost && getScanPostsOfType(scanPost, catalog).length === 0
  );
};

export const CLAVETED_INLAY_CORE_MATERIAL_IDS: ReadonlyArray<string> = [
  "METAL_NON_PRECIOUS",
  "TITANIUM",
];

export const isClavetedInlayCoreMaterial = (
  materialId: string | undefined
): boolean =>
  !!materialId && CLAVETED_INLAY_CORE_MATERIAL_IDS.includes(materialId);
